interface FAQSectionProps {
  faqs: { question: string; answer: string }[];
}

export default function FAQSection({ faqs }: FAQSectionProps) {
  return (
    <section className="max-w-3xl mx-auto">
      <div className="text-center mb-10">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
          常见问题
        </h2>
        <p className="mt-3 text-foreground-600">
          关于家庭教育，妈妈们最关心的问题都在这里
        </p>
      </div>
      <div className="space-y-3">
        {faqs.map((faq, idx) => (
          <details
            key={idx}
            className="group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden"
          >
            <summary className="flex items-center justify-between px-5 py-4 cursor-pointer text-foreground-800 font-medium text-sm md:text-base hover:text-primary-600 transition-colors">
              <span>{faq.question}</span>
              <span className="w-5 h-5 flex items-center justify-center ml-3 flex-shrink-0 transition-transform group-open:rotate-180">
                <i className="ri-arrow-down-s-line"></i>
              </span>
            </summary>
            <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
              {faq.answer}
            </div>
          </details>
        ))}
      </div>
    </section>
  );
}